import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = <any>{
    icons: {
        iconfont: 'mdi'
    },
}

export default new Vuetify(opts)
